import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import PostContent from "./PostContent";

const SidePostPreview = styled.div`
  position: sticky;
  top: ${css.VERTICAL_BOX_MARGIN_LARGE};

  width: 360px;
  box-sizing: border-box;
  min-height: 200px;
  margin: 0 0 50px;
  padding: ${css.BOX_PADDING_PRIMARY};
  z-index: 11;

  border-radius: ${css.BOX_RADIUS_PRIMARY};
  background: ${(props) =>
    props.highlighted
      ? "linear-gradient(138deg,rgb(69, 93, 117) 1.65%, #314151 63.37%)"
      : css.BLUE_BOX_GRADIENT};
  box-shadow: ${(props) =>
    props.highlighted ? "0px 0px 15px 1px rgba(238, 229, 233, 0.5)" : "none"};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    width: 100%;
    margin: ${css.VERTICAL_BOX_MARGIN_LARGE} 0 0;
  }
`;

const Title = styled.div`
  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};

  margin-bottom: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

export default ({
  avatar,
  username,
  text,
  image,
  imageLink,
  video,
  highlighted,
  showCheckmark,
  adPlan,
}) => {
  return (
    <SidePostPreview highlighted={highlighted}>
      <Title>Post Preview</Title>
      <PostContent
        isPreview={true}
        avatar={avatar}
        username={username}
        text={text}
        image={image}
        imageLink={imageLink}
        video={video}
        showCheckmark={showCheckmark}
        adPlan={adPlan}
      />
    </SidePostPreview>
  );
};
